import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { commonApi } from 'core/api/common.api';
import { setAxiosAuth } from 'utils';
import { LocationCombHoursProps } from './types';

export const useGetCombLocationHours = ({
  accessToken = '',
  enabled = true,
}: LocationCombHoursProps) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.locationHours],
    queryFn: async () => await commonApi.getCombLocationHours('STAFF'),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken) && enabled,
  });
}
